import { makeStyles, Theme } from "@material-ui/core/styles";

import { COLOR_BLUE_BASE, COLOR_PRIMARY, HEADER_HEIGHT } from "./constants";

export const useStyles = makeStyles({
  siteHeader: {
    backgroundColor: COLOR_PRIMARY,
    width: "100%",
    height: HEADER_HEIGHT,
    maxHeight: HEADER_HEIGHT,
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  leftItem: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    width: HEADER_HEIGHT * 2.293,
    height: HEADER_HEIGHT,
    backgroundColor: COLOR_BLUE_BASE,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logoItem: {
    borderTop: `${HEADER_HEIGHT}px solid ${COLOR_BLUE_BASE}`,
    borderRight: `${HEADER_HEIGHT / 2}px solid transparent`,
  },
  centerItem: {},
  titleWrapper: {
    margin: `0 ${HEADER_HEIGHT / 5}px`,
    overflow: "hidden",
  },
  title: {
    // title
    margin: 0,
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#fff",
    // text
    lineHeight: "24px",
    letterSpacing: ".15px",
    fontWeight: 500,
    fontSize: "20px",
  },
  textWhite: {
    color: "#fff",
  },
  rightItem: {
    height: "100%",
    marginLeft: "auto",
    marginRight: "50px",
    display: "flex",
    alignItems: "center",
  },
  arrowDown: {
    width: 0,
    height: 0,
    marginLeft: "4px",
    borderLeft: "4px solid transparent",
    borderRight: "4px solid transparent",
    borderTop: "4px solid #fff",
  },
});
